import React from 'react';
import PropTypes from 'prop-types';

function ProductBriefDescription(props) {
  const classes = ['product-desc-wrapper'];

  if (props.icons) {
    classes.push('with-stickers');
  }

  return (
    <div
      className={classes.join(' ')}
    >
      <span className={'product-desc-arrow'} />
      <span className={'product-desc-text'}>{props.descriptionShortened}</span>
      <a className={'product-desc-link'} href={props.link}>
        {props.productDescriptionLinkTranslation}
      </a>
    </div>
  );
}

ProductBriefDescription.propTypes = {
  icons: PropTypes.arrayOf(
    PropTypes.shape({
      imgUrl: PropTypes.string.isRequired,
      linkUrl: PropTypes.string
    })
  ),
  descriptionShortened: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  productDescriptionLinkTranslation: PropTypes.string.isRequired
};

ProductBriefDescription.defaultProps = {
  icons: null
};

export default ProductBriefDescription;
